import { useCallback } from 'react';

import type { LegendItem } from '../../core/components/legend/categorical/types/legend.js';
import { useSetState } from '../store/selectors.js';
import type { TreeMapState } from '../types/state.js';

/**
 * Hook that generates the corresponding handlers to interact with the Treemap
 * @returns Handlers to interact with the Treemap nodes
 */
export function useTreeMapHandlers() {
  const setState = useSetState();
  const onLegendItemHover = useCallback(
    (items: LegendItem[] | undefined): void => {
      setState((prev: TreeMapState) => ({
        ...prev,
        highlightedItems: items,
      }));
    },
    [setState],
  );
  const onLegendItemClick = useCallback(
    (items: LegendItem[]): void => {
      setState((prev: TreeMapState) => ({
        ...prev,
        groupsSelected: items,
      }));
    },
    [setState],
  );

  return { onLegendItemHover, onLegendItemClick };
}
